import { ColorValues } from '@banhala/ui-kit';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const IconBrandIconThirdPL = (props: {
  width: number;
  height: number;
  color?: string;
}) => {
  const color = props.color ?? ColorValues.pink30;

  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox="0 0 49 13"
      fill="none"
    >
      <G clipPath="url(#clip0_icon_third_pl)">
        <Path
          d="M43.9594 1.10994L43.5793 2.52863H41.4076L41.3881 2.60138C40.878 4.50508 41.5581 5.29324 42.9707 5.59637L42.5776 7.06356C41.2613 6.86955 40.2247 6.28753 39.8059 5.41449C38.8815 6.28753 37.4783 7.02718 36.0677 7.18481L36.4576 5.72976C38.0326 5.42662 39.1518 4.52933 39.6684 2.60138L39.6878 2.52863H37.5287L37.9089 1.10994H43.9594ZM46.4933 3.36528H48.0875L47.6977 4.82034H46.1034L45.4309 7.33032H43.7112L45.4136 0.976562H47.1334L46.4933 3.36528ZM36.0397 9.91305C36.2314 9.19765 36.6882 8.66412 37.3161 8.28823C38.3038 7.69409 39.7054 7.47583 41.1741 7.47583C42.6428 7.47583 43.9275 7.69409 44.5968 8.28823C45.0233 8.66412 45.1942 9.19765 45.0025 9.91305C44.8108 10.6285 44.354 11.162 43.7261 11.5379C42.7384 12.132 41.3368 12.3503 39.8681 12.3503C38.3994 12.3503 37.1147 12.132 36.4454 11.5379C36.0189 11.162 35.848 10.6285 36.0397 9.91305ZM37.7595 9.91305C37.688 10.1798 37.7583 10.3859 37.9671 10.5436C38.3536 10.8346 39.1937 10.9316 40.2482 10.9316C41.3152 10.9316 42.1948 10.8346 42.7498 10.5436C43.0305 10.3859 43.2113 10.1798 43.2827 9.91305C43.351 9.65841 43.2807 9.45228 43.0844 9.29465C42.6886 8.99151 41.8578 8.90663 40.7908 8.90663C39.7363 8.90663 38.8474 8.99151 38.3017 9.29465C38.0084 9.45228 37.8277 9.65841 37.7595 9.91305Z"
          fill={color}
        />
        <Path
          d="M33.9164 3.23272L34.4687 1.17139H36.1885L34.3626 7.98591H30.6971L30.109 10.1806H34.3519L33.9653 11.6236H23.7221L24.1087 10.1806H28.4018L28.9899 7.98591H25.2742L27.1001 1.17139H28.8199L28.2676 3.23272H33.9164ZM33.5265 4.68778H27.8777L27.3839 6.53085H33.0327L33.5265 4.68778Z"
          fill={color}
        />
        <Path
          d="M20.7051 2.0196L20.325 3.43828H18.1659C17.8435 5.06309 18.518 5.7785 19.8399 6.04526L19.4468 7.51244C18.1305 7.31843 17.1251 6.76066 16.6686 5.88763C15.7317 6.76066 14.3475 7.47607 12.9337 7.64582L13.3268 6.17864C14.7949 5.89975 15.8597 5.11159 16.421 3.43828H14.2745L14.6546 2.0196H16.8137L17.1809 0.649414H18.9006L18.5335 2.0196H20.7051ZM23.4308 3.55953H25.025L24.6351 5.01459H23.0409L22.3586 7.56094H20.6389L22.403 0.976802H24.1228L23.4308 3.55953ZM22.1994 8.15509L21.0915 12.2899H19.3718L20.0963 9.5859H13.1168L13.5002 8.15509H22.1994Z"
          fill={color}
        />
        <Path
          d="M5.43564 2.62645L4.56492 5.87608H11.9963L11.6064 7.33114H7.87817L7.11467 10.1806H11.3576L10.9709 11.6236H0.727732L1.11436 10.1806H5.40747L6.17097 7.33114H2.45529L4.10576 1.17139H13.1941L12.8042 2.62645H5.43564Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_icon_third_pl">
          <Rect width={49} height={13} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
